import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/view/components/ui/dropdown-menu";
import { Calendar, Wallet, AArrowDown } from "lucide-react";
import { ReactNode } from "react";

type Props = {
  sort: string;
  sortIcon: ReactNode;
  onSortChange: (value: string) => void;
};

export const CustomerSortDropdown = ({
  sort,
  sortIcon,
  onSortChange,
}: Props) => {
  return (
    <div className="ml-2 flex h-11 w-11 items-center rounded-lg border-b border-r border-t border-gray-200 bg-white02 px-3">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button type="button" className="text-primaryHex">
            {sortIcon}
          </button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="center" className="mr-24 mt-2">
          <DropdownMenuItem
            className={`py-3 ${sort === "available.updatedAt" ? "bg-gray-100 text-primaryHex" : ""}`}
            onSelect={() => onSortChange("available.updatedAt")}
          >
            <Calendar size={20} className="mr-2" />
            Data
          </DropdownMenuItem>

          <DropdownMenuItem
            className={`py-3 ${sort === "name" ? "bg-gray-100 text-primaryHex" : ""}`}
            onSelect={() => onSortChange("name")}
          >
            <AArrowDown size={20} className="mr-2" />
            Nome
          </DropdownMenuItem>

          <DropdownMenuItem
            className={`py-3 ${sort === "available.amount" ? "bg-gray-100 text-primaryHex" : ""}`}
            onSelect={() => onSortChange("available.amount")}
          >
            <Wallet size={20} className="mr-2" />
            Saldo
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
